import { FC ,memo} from "react";
import { CopayClaimsData, NotTreatedData } from "src/pages/actionDashboard/types";
import NoDataFound from "src/components/noDataFoundComponent";
import CopayBucketTableRow from "./copayBucketTableRow";

type Props = {
  data: CopayClaimsData[];
  refreshListing: () => void;
};

const CopayBucketTableBody: FC<Props> = ({ data, refreshListing }) => (
  
  <tbody>
    {data && data.length > 0 ?
      data.map((row, idx) => (
        <CopayBucketTableRow
          row={row}
          refreshListing={refreshListing}
          index={idx}
        />
      )):<NoDataFound/>
      }
  </tbody>
);

export default memo(CopayBucketTableBody);
